import React, { useState } from "react"
import changePassword from "./form-handlers/change-password"
import { Button } from "../button"
import { SuccessNotice } from "../notice"

export default function ChangePasswordForm({ email }) {
  const [okStatus, setOkStatus] = useState()

  async function buttonHandler() {
    const status = await changePassword(email)
    setOkStatus(status)
  }

  return (
    <div className="flex h-full">
      <div>
        <h3 className="font-bold text-lg lg:text-xl text-gray-800 py-3 mt-4">
          Change Your Password
        </h3>

        {okStatus ? (
          <SuccessNotice>
            Thank you. We have received your request and an email has been sent.
            Please check your inbox for further instructions.
          </SuccessNotice>
        ) : (
          <>
            <p className="mb-6">
              To change your password please click the button below. You will
              receive an email containing a link that you can use to set your
              new password.
            </p>
          </>
        )}
        <Button
          label="Update"
          onClick={buttonHandler}
          className="w-auto float-right"
        >
          Request Password Change Email
        </Button>
      </div>
    </div>
  )
}
